/**
 * StaffPortalLeaveDutyService
 * Manages duty delegations attached to one of the caller's own leave applications.
 * Route: api/staff-portal/leaves/{leaveId}/duties
 */
import { StaffPortalBaseService } from './StaffPortalBaseService';
export class StaffPortalLeaveDutyService extends StaffPortalBaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? StaffPortalLeaveDutyService.DEFAULT_SERVICE_PATH,
            basePath: config?.basePath ?? StaffPortalLeaveDutyService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    /** List delegations on a given leave. */
    async getDuties(leaveId) {
        return (await this.getDutiesRaw(leaveId)).data ?? [];
    }
    getDutiesRaw(leaveId) {
        return this.get(`${leaveId}/duties`);
    }
    /** Add a new delegation. Pick a catalogue duty OR set a custom name. */
    async addDuty(leaveId, body) {
        return (await this.addDutyRaw(leaveId, body)).data ?? null;
    }
    addDutyRaw(leaveId, body) {
        return this.post(`${leaveId}/duties`, body);
    }
    /** Remove a delegation. */
    async removeDuty(leaveId, leaveDutyId) {
        return (await this.removeDutyRaw(leaveId, leaveDutyId)).success ?? false;
    }
    removeDutyRaw(leaveId, leaveDutyId) {
        return this.delete(`${leaveId}/duties/${leaveDutyId}`);
    }
}
// All staff portal endpoints route through the HRManagement API gateway.
StaffPortalLeaveDutyService.DEFAULT_SERVICE_PATH = 'hr';
// Note: the leaveId is a path segment baked into every call rather than the
// class basePath, since the same service handles every leave the staff member owns.
StaffPortalLeaveDutyService.BASE_PATH = 'api/staff-portal/leaves';
//# sourceMappingURL=StaffPortalLeaveDutyService.js.map